import styled from 'styled-components/macro';
import { mediaDown } from '../../../utils/styles/media';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f8f9fa;
  padding: 20px;
`;

const Container = styled.div`
  text-align: center;
  background: white;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 56px;
  font-weight: bold;
  color: #e3342f;
  margin-bottom: 16px;
  ${mediaDown('md')`
    font-size: 40px;
  `}
`;

const Message = styled.p`
  font-size: 18px;
  color: #555;
  margin-bottom: 32px;
`;

const Button = styled.button`
  background-color: #e3342f;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #cc1f1a;
  }
`;

const Styled = {
  Wrapper,
  Container,
  Title,
  Message,
  Button,
};

export default Styled;
